(function ($) {
    'use strict';

    var Gronvalls = {

        init: function () {
            this.themeChooser();
            this.navMenu();
            this.scroll();
            this.loader();
        },

        themeChooser: function () {
			// if(localStorage.getItem('theme-mode') === "false" || localStorage.getItem('theme-mode') === "" || localStorage.getItem('theme-mode') === undefined) {
			// 	jQuery('#theme-chooser').prop('checked', false);
			// 	jQuery('html').removeClass('theme-dark').addClass('theme-default ');
			// }else {
			// 	jQuery('#theme-chooser').prop('checked', true);
			// 	jQuery('html').removeClass('theme-default').addClass('theme-dark');
			// }
			//
			// jQuery('.theme-switcher').on('change', '#theme-chooser', function() {
			// 	if(this.checked) {
			// 		jQuery('html').removeClass('theme-default').addClass('theme-dark');
			// 		localStorage.setItem('theme-mode', "true");
			// 	}else {
			// 		jQuery('html').removeClass('theme-dark').addClass('theme-default');
			// 		localStorage.setItem('theme-mode', "false");
			// 	}
			// });ß
        },

		navMenu: function () {
			jQuery('.navbar').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('body').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');
					//         jQuery('header').removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('body').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}
			});

			// for the mob menu
			$(".navbar-nav .submenu-opener").on('click', function (e) {
				e.preventDefault();

				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').css('display', 'block');
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').css('display', 'none');
				}
			});

			//active menu-bar
			jQuery('.navbar .navbar-nav a').on('click', function () {
				jQuery('.navbar .navbar-nav').find('li.active').removeClass('active');
				jQuery(this).parent('li').addClass('active');
			});

			// sticky
			jQuery(window).scroll(function () {
				if (jQuery(window).scrollTop() >= 20) {
					// jQuery('header .header-top').addClass('sticky-top');
					jQuery('header ').addClass('sticky');
				}
				else {
					jQuery('header ').removeClass('sticky');
					// jQuery('header .header-top').removeClass('sticky-top');
				}
			});
		},

		scroll: function () {
			jQuery(document).ready(function () {
				jQuery(".down-arrow").click(function () {
					jQuery('html, body').animate({
						scrollTop: jQuery(".down-arrow").offset().top

					}, 1000 );
				});
			});
		},

		loader: function () {
			setTimeout(function(){ // allowing 3 secs to fade out loader
				jQuery('.pageloader').fadeOut('slow');
			},1500);
		}
    };

    Gronvalls.init();

})(jQuery);
